<template>
  <div>
    <title>库存管理</title>
    <!--S 公用头部切换-->
    <GoodsInfoTab :active="currentTit"></GoodsInfoTab>
    <!--E 公用头部切换-->
    
    <!-- S 库存管理组件 -->
    <GoodsStockPage></GoodsStockPage>
    <!-- E 库存管理组件 -->

  </div>
</template>
<script>
export default {
  name: 'GoodsInventoryMange',
  data () {
    return {
      currentTit:2, //当前选中菜单
    }
  },
  components: {
    GoodsInfoTab: resolve => require(["@/components/GoodsFolder/GoodsInfoTab.vue"],resolve),
    GoodsStockPage:resolve => require(["@/components/common/GoodsStockPage.vue"],resolve), // 库存管理组件
  },
  methods: {
  },
  created() {
    
  },
  mounted () {
    sessionStorage.setItem('operateNotSaved','');
  },
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/GoodsFolder/GoodsCommodity/GoodsInventoryMange.vue